/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tree_Type_131_TitleInputs */

const en_tree_type_131_title = /** @type {(inputs: Tree_Type_131_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendula`)
};

const ar_tree_type_131_title = /** @type {(inputs: Tree_Type_131_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كالينديولا`)
};

const de_tree_type_131_title = /** @type {(inputs: Tree_Type_131_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ringelblume`)
};

const es_tree_type_131_title = /** @type {(inputs: Tree_Type_131_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caléndula`)
};

const fr_tree_type_131_title = /** @type {(inputs: Tree_Type_131_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendula`)
};

const it_tree_type_131_title = /** @type {(inputs: Tree_Type_131_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendula`)
};

const ja_tree_type_131_title = /** @type {(inputs: Tree_Type_131_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カレンデュラ`)
};

const ko_tree_type_131_title = /** @type {(inputs: Tree_Type_131_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`금잔화`)
};

const pt_br_tree_type_131_title = /** @type {(inputs: Tree_Type_131_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calêndula`)
};

const ru_tree_type_131_title = /** @type {(inputs: Tree_Type_131_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Календула`)
};

const th_tree_type_131_title = /** @type {(inputs: Tree_Type_131_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดาวเรือง`)
};

const tr_tree_type_131_title = /** @type {(inputs: Tree_Type_131_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aynısefa çiçeği`)
};

const zh_cn_tree_type_131_title = /** @type {(inputs: Tree_Type_131_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`金盏花`)
};

const zh_tw_tree_type_131_title = /** @type {(inputs: Tree_Type_131_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`金盞花`)
};

/**
* | output |
* | --- |
* | "Calendula" |
*
* @param {Tree_Type_131_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const tree_type_131_title = /** @type {((inputs?: Tree_Type_131_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tree_Type_131_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tree_type_131_title(inputs)
	if (locale === "ar") return ar_tree_type_131_title(inputs)
	if (locale === "de") return de_tree_type_131_title(inputs)
	if (locale === "es") return es_tree_type_131_title(inputs)
	if (locale === "fr") return fr_tree_type_131_title(inputs)
	if (locale === "it") return it_tree_type_131_title(inputs)
	if (locale === "ja") return ja_tree_type_131_title(inputs)
	if (locale === "ko") return ko_tree_type_131_title(inputs)
	if (locale === "pt_br") return pt_br_tree_type_131_title(inputs)
	if (locale === "ru") return ru_tree_type_131_title(inputs)
	if (locale === "th") return th_tree_type_131_title(inputs)
	if (locale === "tr") return tr_tree_type_131_title(inputs)
	if (locale === "zh_cn") return zh_cn_tree_type_131_title(inputs)
	return zh_tw_tree_type_131_title(inputs)
});